<script lang="ts">
  import type { Translate } from "../i18n";
  import Icon from "./Icon.svelte";

  /**
   * The rail is only what a player reaches for mid-run: the clock and the
   * camera. Everything that is set once and forgotten lives behind the gear,
   * in `SettingsOverlay`.
   */
  const {
    paused,
    canZoomIn,
    canZoomOut,
    t,
    onTogglePause,
    onRotate,
    onZoom,
    onOpenScores,
    onOpenSettings,
  }: {
    paused: boolean;
    canZoomIn: boolean;
    canZoomOut: boolean;
    t: Translate;
    onTogglePause: () => void;
    onRotate: (direction: "left" | "right") => void;
    onZoom: (direction: "in" | "out") => void;
    onOpenScores: () => void;
    onOpenSettings: () => void;
  } = $props();
</script>

<div class="panel rail" role="group" aria-label={t("controls.group")}>
  <button
    type="button"
    class="rail__button"
    aria-label={paused ? t("controls.resume") : t("controls.pause")}
    onclick={onTogglePause}
  >
    <span class="rail__chip"><Icon name={paused ? "play" : "pause"} /></span>
  </button>

  <button
    type="button"
    class="rail__button"
    aria-label={t("controls.rotateLeft")}
    onclick={() => onRotate("left")}
  >
    <span class="rail__chip"><Icon name="rotate-left" /></span>
  </button>

  <button
    type="button"
    class="rail__button"
    aria-label={t("controls.rotateRight")}
    onclick={() => onRotate("right")}
  >
    <span class="rail__chip"><Icon name="rotate-right" /></span>
  </button>

  <button
    type="button"
    class="rail__button"
    aria-label={t("controls.zoomIn")}
    disabled={!canZoomIn}
    onclick={() => onZoom("in")}
  >
    <span class="rail__chip"><Icon name="zoom-in" /></span>
  </button>

  <button
    type="button"
    class="rail__button"
    aria-label={t("controls.zoomOut")}
    disabled={!canZoomOut}
    onclick={() => onZoom("out")}
  >
    <span class="rail__chip"><Icon name="zoom-out" /></span>
  </button>

  <button
    type="button"
    class="rail__button"
    aria-label={t("controls.scores")}
    onclick={onOpenScores}
  >
    <span class="rail__chip"><Icon name="trophy" /></span>
  </button>

  <button
    type="button"
    class="rail__button"
    aria-label={t("controls.settings")}
    onclick={onOpenSettings}
  >
    <span class="rail__chip"><Icon name="settings" /></span>
  </button>
</div>
